import { queryOptions } from '@tanstack/react-query';
import { ApiError } from '~/components/Providers/APIClient';
import { RawLeaderboardResponse } from '../../types/leaderboard';
import { apiQueryFn } from '../utils';

export type LeaderboardQueryParams = {
    list: 'classic' | 'platformer';
    type: 'users' | 'countries' | 'clans';
    page?: number;
    perPage?: number;
    nameFilter?: string;
    clanFilter?: string;
    sort?: 'RawPoints' | 'TotalPoints' | 'ExtremeCount' | 'Hardest';
    countryFilter?: number;
};

export const LeaderboardQuery = ({
    list,
    type,
    page,
    perPage,
    nameFilter,
    clanFilter,
    sort,
    countryFilter,
}: LeaderboardQueryParams) => {
    const normalized = {
        sort: sort ?? 'RawPoints',
        page: type === 'countries' ? 1 : (page ?? 1),
        perPage: type === 'countries' ? 500 : (perPage ?? 20),
        nameFilter: type === 'countries' ? undefined : `%${nameFilter ?? ''}%`,
        clanFilter: type === 'users' ? clanFilter : undefined,
        countryFilter:
            type === 'users'
                ? countryFilter !== 0
                    ? countryFilter
                    : undefined
                : undefined,
    };
    return queryOptions<RawLeaderboardResponse, ApiError>({
        queryKey: [
            'leaderboard',
            list,
            type,
            normalized.sort,
            normalized.page,
            normalized.perPage,
            normalized.nameFilter,
            normalized.clanFilter,
            normalized.countryFilter,
        ],
        queryFn: apiQueryFn<RawLeaderboardResponse>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/leaderboard${type == 'countries' ? '/countries' : type == 'clans' ? '/clans' : ''}`,
            query: {
                page: normalized.page,
                per_page: normalized.perPage,
                name_filter: normalized.nameFilter,
                order: normalized.sort,
                country_filter: normalized.countryFilter,
                clan_filter: normalized.clanFilter,
            },
        }),
    });
};
